import axios from "axios";
import qs from "qs";
import route from "../../router/index";
import { MessageBox } from "element-ui";
import { Loading } from "element-ui";
let instance = axios.create({
  timeout: 60000,
  baseURL: process.env.NODE_ENV === "development" ? "/api" : "/"
});
var loadingInstance = "";
instance.interceptors.request.use(
  config => {
    loadingInstance = Loading.service({
      text: "",
      background: "rgba(0,0,0,0)"
    });
    !config.hideLoading && loadingInstance;

    if (
      (config.method === "post" || config.method === "put") &&
      !config.noStringify
    ) {
      config.data = qs.stringify(config.data);
    }
    if (!config.headers.Authorization) {
      config.headers.Authorization =
        "Bearer " + (window.sessionStorage.getItem("Authorization") || "");
    }
    var sbzRegion = localStorage.getItem("sbzRegion");
    if (sbzRegion) {
      sbzRegion = JSON.parse(sbzRegion);
      config.headers["SBZ-REGION"] = sbzRegion.value;
    }
    var company = sessionStorage.getItem("company");
    if (company) {
      config.headers["Company"] = company;
    }
    config.headers["PAGE-TYPE"] = "pc";
    var actId = sessionStorage.getItem("activityId");
    if (actId) {
      config.headers["ACT-ID"] = actId;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
instance.interceptors.response.use(
  res => {
    setTimeout(() => {
      loadingInstance.close();
    }, 0);
    let data = res.data;
    if (!data.success) {
      if (data.error && data.error.message && !res.config.noAlertMessage) {
        MessageBox.alert("错误信息：" + data.error.message).then(() => {
          if (route.currentRoute.fullPath == "/checkOrder")
            route.replace({ path: "/shoppingCart" });
        });
      }
      let err;
      if (data.error && data.error.message) {
        MessageBox.alert("错误信息：" + data.error.message);
        err = new Error(data.error.message);
      } else {
        err = new Error("服务器跑路了...");
      }
      err.response = data;
      return Promise.reject(err);
    }
    return res;
  },
  error => {
    setTimeout(() => {
      loadingInstance.close();
    }, 0);
    if (error.response.config.noAlertMessage) {
      return Promise.reject(error);
    }
    if (error.response && error.response.status == 401) {
      if (!route.currentRoute.query.redirect) {
        route.replace({
          path: "/login",
          query: { redirect: route.currentRoute.fullPath }
        });
      }
    } else if (error.response && error.response.status == 400) {
      MessageBox.alert("错误信息：" + error.response.data.error.message);
    } else if (
      error.response.data &&
      error.response.data.error &&
      error.response.data.error.message
    ) {
      MessageBox.alert("错误信息：" + error.response.data.error.message);
    } else {
      MessageBox.alert("系统繁忙，请稍后再试");
    }
    return Promise.reject(error);
  }
);

const post = (url, data, config = {}) => {
  return instance.post(url, data, config);
};

const put = (url, data, config = {}) => {
  return instance.put(url, data, config);
};

const get = (url, params, config = {}) => {
  return instance.get(url, {
    params: params,
    ...config
  });
};

const deleteMethod = (url, config = {}) => {
  return instance({
    url: url,
    method: "delete",
    ...config
  });
};

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $reqGet: {
        value: get
      },
      $reqPost: {
        value: post
      },
      $reqPut: {
        value: put
      },
      $reqDel: {
        value: deleteMethod
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/axios.js